import React from "react";
import classes from "./Confirmation.module.css";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

export const Confirmation: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.icon}>✓</div>
        {/* <img src="/images/confirmation.png" alt="Success" /> */}
        <h1 className={classes.title}>{t("common.submission_successful")}</h1>
        <p className={classes.subtitle}>{t("common.thankyou_message")}</p>
        <button
          className={classes.button}
          onClick={() => {
            navigate("/");
            sessionStorage.removeItem("country");
            sessionStorage.removeItem("countryId");
          }}
        >
          {t("common.back_home")}
        </button>
      </div>
    </div>
  );
};
